
let SelectBase = null

if (process.env.BABEL_ENV && process.env.BABEL_ENV === "dingo") {
  SelectBase = require("./dingo").default
} else {
  SelectBase = require("./koala").default
}

export default SelectBase



// WEBPACK FOOTER //
// ./src/components/form-elements/select-base/index.jsx